import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Tab } from '../../internal/Tab/Tab';
import { ScrollTrack } from '../../internal/ScrollTrack/ScrollTrack';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var TabsComponent = function TabsComponent(_ref) {
  var activeTab = _ref.activeTab,
    tabs = _ref.tabs,
    onChange = _ref.onChange;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusVisible = _React$useState2[0],
    setFocusVisible = _React$useState2[1];
  var _onClick = function onClick(_ref2) {
    var value = _ref2.value;
    setFocusVisible(false);
    onChange(value);
  };
  return /*#__PURE__*/_jsx(ScrollTrack, {
    setFocusVisible: setFocusVisible,
    activeTab: activeTab,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: tabs.map(function (_ref3) {
        var value = _ref3.value,
          title = _ref3.title,
          disabled = _ref3.disabled;
        return /*#__PURE__*/_jsx(Tab, {
          title: title,
          disabled: disabled,
          active: value === activeTab,
          focusVisible: focusVisible,
          onClick: function onClick(e) {
            return _onClick({
              e: e,
              value: value
            });
          }
        }, value);
      })
    })
  });
};

/**
 * Компонент для рендера табов со стрелками прокрутки
 *
 * @deprecated требуется реализация с другим API для фикса https://jira.cian.tech/browse/CD-113225
 */
export var Tabs = /*#__PURE__*/React.memo(TabsComponent);